export const VEHICLE_SEARCH_HINT =
  'Search cost centre, registration, vehicle or driver';

export const ALLOCATION_DETAIL_HEADING = 'Allocation Details';

export const ALLOCATION_INFO_REGISTRATION = 'Registration number';
export const ALLOCATION_INFO_LEASEID = 'Lease ID';

export const ALLOCATION_INFO_DRIVER = 'Driver';
export const ALLOCATION_INFO_ALLOCATION_PERIOD = 'Allocation period';

export const DRIVERS_HISTORY = 'Past drivers';

export const SELECT_DATE_HEADING = 'Select effective date';
export const SELECT_DATE_HINT =
  'This is the date in which the cost centre change will take effect.';

export const CHANGE_COSTCENTER_HEADING = 'Change cost centres?';
export const CHANGE_COSTCENTER_HINT =
  'Please note that changes made to vehicle cost centres will directly affect invoicing.';
export const CONFIRM_ACCEPT_LABEL =
  'I have read and agreed to the &nbsp; <a href="/terms_and_conditions.pdf" target="_blank">Terms and Conditions</a>';

export const RECORD_NUMBER = 20;

export const ALLOCATION_INFO_CURRENT_DRIVER = 'Current Driver';

export const ALLOCATION_INFO_DIFFERENT_DRIVER = 'Allocate a different driver';

export const ALLOCATED_INFO_ALLOCATED_ON = 'Allocated on';

export const ALLOCATED_INFO_DRIVER_PROFILE = 'Driver Profile';
export const ALLOCATED_INFO_DRIVER_PROFILE_FIRST_NAME = 'First name';
export const ALLOCATED_INFO_DRIVER_PROFILE_LAST_NAME = 'Last name';
export const ALLOCATED_INFO_DRIVER_PROFILE_LICENSE_NO = 'Licence number';
export const ALLOCATED_INFO_DRIVER_PROFILE_ISSUING_STATE = 'Issuing state';
export const ALLOCATED_INFO_DRIVER_PROFILE_EMAIL_ID = 'Email address';
export const ALLOCATED_INFO_DRIVER_PROFILE_MOBILE_NO = 'Mobile number';

export const ALLOCATED_INFO_PAST_VEHICLES = 'Past vehicles';
export const ALLOCATED_INFO_PAST_VEHICLES_VEHICLE = 'Vehicle';
export const ALLOCATED_INFO_PAST_VEHICLES_REGISTRATION = 'Registration';
export const ALLOCATED_INFO_PAST_ALLOCATION_PERIOD = 'Allocation period';

export const ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER =
  'Allocate a different driver';
export const AALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NOTIFY_CONTENT =
  "Driver allocation change may impact on the driver's level of Reportable Fringe Benefits which is referred on their Payment Summary.";
export const ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NOTIFY_CANCEL = 'Cancel';
export const ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NOTIFY_CONTINUE =
  'Continue';

export const ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_SELECT_EXISTING_DRIVER =
  'Select existing driver';
export const ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_SELECT_EXISTING_DRIVER_SRCH_DRVR_NAME =
  'Search driver name';
export const ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_SET_ALLOC_DATE =
  'Set allocation date*';
export const ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_SELECT_EXISTING_DRIVER_ALLOCATE =
  'Allocate';

export const ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_CREATE_NEW_DRIVER =
  'Create new driver';

export const CHANGE_DRIVER_SUCCESS_TITLE =
  'Driver allocation change successful';

export const ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_MANDATORY =
  '* denotes mandatory fields';
export const ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_FIRST_NAME =
  'First name*';
export const ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_LAST_NAME =
  'Last name*';
export const ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_LICENSE_NO =
  'Licence number';
export const ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_ISSUING_STATE =
  'Issuing state';
export const ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_EMAIL_ID =
  'Email address*';
export const ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_MOBILE_NO =
  'Mobile number*';
export const ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_SET_ALLOCATION_DATE =
  'Set allocation date';
export const ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_PAYROLL_NO =
  'Payroll Number';
export const ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NEW_DRIVER_BUSINESS_ADDRESS =
  'Business Mailing Address';

export const DASHBOARD_LINK = '/dashboard';



// WEBPACK FOOTER //
// ./src/features/relocations/driver/content.js